"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomePremiumChoiceWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var PremiumChoiceComponent_1 = require("../../../components/annual/PremiumChoiceComponent");
var journey_model_1 = require("@athena-portal/journey-model");
var MonthlyPaymentInfo_1 = require("../common/MonthlyPaymentInfo");
var AnnualHomePremiumChoiceWidget = exports.AnnualHomePremiumChoiceWidget = /** @class */ (function (_super) {
    __extends(AnnualHomePremiumChoiceWidget, _super);
    function AnnualHomePremiumChoiceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = function (event) {
            _this.props.onStateChange("factors.premiumType", event.target.value);
        };
        _this.state = {
            collapse: "notCollapsedWithArrowAtTheEnd",
            display: "none",
            showComprehensiveCover: _this.getSetting("showComprehensiveCover", true),
            hideDepositValue: _this.getSetting("hideDepositValue", false),
        };
        _this.collapseElement = _this.collapseElement.bind(_this);
        return _this;
    }
    AnnualHomePremiumChoiceWidget.prototype.render = function () {
        return (React.createElement("div", { className: "premium-output no-shadow mb-0" },
            React.createElement("div", { className: this.getSetting('cssClass', 'top-section pb-5') },
                React.createElement(PremiumChoiceComponent_1.PremiumChoiceComponent, { interaction: this.props.interaction, onChange: this.handleOnChangeEvent, hideDepositValue: this.state.hideDepositValue }),
                this.shouldShowMonthlyDetails() && this.renderMonthlyPaymentDetails(),
                this.state.showComprehensiveCover && this.renderComprehensiveCover())));
    };
    AnnualHomePremiumChoiceWidget.prototype.shouldShowMonthlyDetails = function () {
        var paymentOption = this.props.interaction.factors ? this.props.interaction.factors.premiumType : undefined;
        var instalmentPlanCalculated = this.props.interaction.paymentDetails.instalmentPlan && this.props.interaction.paymentDetails.instalmentPlan.instalmentPlanParameters;
        return paymentOption === "monthly" && instalmentPlanCalculated;
    };
    AnnualHomePremiumChoiceWidget.prototype.renderMonthlyPaymentDetails = function () {
        var annualPrice = this.props.interaction.factors.annualPremium;
        var deposit = this.props.interaction.paymentDetails.instalmentPlan.deposit;
        var numberOfInstalments = this.props.interaction.paymentDetails.instalmentPlan.instalmentPlanParameters.numberOfInstalments;
        var instalmentPrice = this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment;
        var interestRate = this.props.interaction.paymentDetails.instalmentPlan.instalmentPlanParameters.interestRate;
        var depositPercentage = this.props.interaction.paymentDetails.instalmentPlan.instalmentPlanParameters.depositPercentage;
        var APR = this.props.interaction.paymentDetails.instalmentPlan.apr;
        var totalAmount = this.props.interaction.paymentDetails.instalmentPlan.totalAmount;
        var creditCost = this.props.interaction.paymentDetails.instalmentPlan.creditCost;
        return (React.createElement("div", { className: "widget" },
            React.createElement("div", null,
                this.renderMonthlyPaymentInfo(),
                React.createElement("div", { className: "d-block" },
                    React.createElement("table", { className: "payment-choice-table mb-3" },
                        !this.state.hideDepositValue && React.createElement("tr", { className: "payment-choice-row-white" },
                            React.createElement("td", null,
                                "First payment / deposit, ",
                                depositPercentage,
                                "% of the annual price (",
                                (0, commonFunctions_1.getAmountWithDecimalDigits)(annualPrice),
                                ")"),
                            React.createElement("td", null, (0, commonFunctions_1.getAmountWithDecimalDigits)(deposit))),
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                numberOfInstalments,
                                " payments of"),
                            React.createElement("td", null, (0, commonFunctions_1.getAmountWithDecimalDigits)(instalmentPrice))),
                        React.createElement("tr", { className: "payment-choice-row-white" },
                            React.createElement("td", null, "Interest rate"),
                            React.createElement("td", null,
                                interestRate,
                                "%")),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Credit representative APR"),
                            React.createElement("td", null,
                                APR,
                                "% **")),
                        React.createElement("tr", { className: "payment-choice-row-white" },
                            React.createElement("td", null, "Credit cost"),
                            React.createElement("td", null, (0, commonFunctions_1.getAmountWithDecimalDigits)(creditCost))),
                        React.createElement("tr", { className: "payment-choice-row-blue" },
                            React.createElement("td", null, "Total amount for 1 year"),
                            React.createElement("td", null,
                                React.createElement("b", null, (0, commonFunctions_1.getAmountWithDecimalDigits)(totalAmount)))))))));
    };
    AnnualHomePremiumChoiceWidget.prototype.renderMonthlyPaymentInfo = function () {
        return MonthlyPaymentInfo_1.MonthlyPaymentInfo.renderMonthlyPaymentInfo();
    };
    AnnualHomePremiumChoiceWidget.prototype.renderComprehensiveCover = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "d-flex justify-content-center font-weight-bold mb-1" },
                React.createElement("b", null, "Home insurance, underwritten by Liverpool Victoria Insurance Company Limited, which is an Allianz Group company")),
            React.createElement("div", { className: "d-flex justify-content-center font-weight-medium mt-3" }, "* All figures include Insurance Premium Tax."),
            this.shouldShowMonthlyDetails() &&
                React.createElement("div", { className: "d-flex justify-content-center font-weight-medium" }, "** Credit supplied by Liverpool Victoria Insurance Company Limited, which is an Allianz Group company")));
    };
    AnnualHomePremiumChoiceWidget.prototype.collapseElement = function (event) {
        if (event.target.className === "notCollapsedWithArrowAtTheEnd text-decoration-underline") {
            this.setState({ collapse: "collapsedWithArrowAtTheEnd", display: "block" });
        }
        if (event.target.className === "collapsedWithArrowAtTheEnd text-decoration-underline") {
            this.setState({ collapse: "notCollapsedWithArrowAtTheEnd", display: "none" });
        }
    };
    AnnualHomePremiumChoiceWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "showComprehensiveCover", type: journey_model_1.TypeDescriptions.Boolean },
            { name: "hideDepositValue", type: journey_model_1.TypeDescriptions.Boolean }
        ]),
        __metadata("design:paramtypes", [Object])
    ], AnnualHomePremiumChoiceWidget);
    return AnnualHomePremiumChoiceWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualHomePremiumChoiceWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/AnnualHomePremiumChoiceWidget.js
// module id = 3678
// module chunks = 0